import { render, staticRenderFns } from "./OpcoesFrequencia.vue?vue&type=template&id=5ce1a7e8"
import script from "./OpcoesFrequencia.vue?vue&type=script&lang=js"
export * from "./OpcoesFrequencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports